import React, { useCallback, useState } from 'react';
import { client as api } from '../services/api';
import { ArProps } from '../types/types';

interface UsePostalCodeResult {
  locales: ArProps[];
  isLoading: boolean;
  error: string | null;
  videoConference: boolean;
  handlePostalCodeSearch: (e?: React.FormEvent) => Promise<void>;
  resetSearchResults: () => void;
}

const usePostalCodeResult = (
  postalCode: string,
  orderId: string | undefined,
  videoConference: boolean
): UsePostalCodeResult => {
  const [locales, setLocales] = useState<ArProps[]>([]);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const resetSearchResults = useCallback(() => {
    setLocales([]);
    setError(null);
    setLoading(false);
  }, []);

  const handlePostalCodeSearch = async (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }
    if (!postalCode || !orderId) return;

    setLoading(true);
    setError(null);
    try {
      const cnhOpt = videoConference ? 'true' : 'false';
      const response = await api.get(
        `/agendamento/postos/${orderId}/${cnhOpt}/${postalCode.replace('-', '')}`
      );
      if (response.status === 200 && response.data === '') {
        setError('Erro ao buscar o CEP, tente novamente.');
      }
      setLocales(response.data);
    } catch (error) {
      setError('Erro ao buscar locais. Tente novamente mais tarde.');
      console.error('Erro ao buscar locais:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    locales,
    isLoading,
    error,
    videoConference,
    handlePostalCodeSearch,
    resetSearchResults,
  };
};

export default usePostalCodeResult;
